module.exports = __webpack_public_path__ + "images/icons/icon-payment-master_card-eaa5f44f.svg";